import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, NavLink } from "react-router-dom";
import OnboardingVideo from "../../assets/images/onboarding-vdo.mp4";

import Modal from "react-bootstrap/Modal";
import { useDispatch } from "react-redux";
import { getOnboardingDetails, onboardingQuestions, setDataForStates, setOnboardingData } from "../../shared/_services/common.services";
import { setSkipModalData } from "../../redux/onboardingReducer";
import Loader from "../Loader";
import AIChatBot from "./AIChatBot";


const QuestionOne = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [selectedOptions, setSelectedOptions] = useState(new Array(5).fill(null));
  const [remainingOptions, setRemainingOptions] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [allQuestions, setAllQuestions] = useState([]);
  const isFromUserQuestionnaire = location?.state?.fromUserQuestionnaire;
  const [showLoaderOne, setShowLoaderOne] = useState(false);
  const [otherInput, setOtherInput] = useState("");
  const quickSetup = JSON.parse(localStorage.getItem("currentUser"))?.user?.quickSetup;

  const tooltipDescriptions = {
    "Short Term Planning": "Setting your financial goals for the next 1 to 5 years; strategies focused on your immediate financial needs. (ex: yearly budget planning, establishing an emergency savings account,paying off credit cards; contribute maximum amount into 401K plan)",
    "Long Term Planning": "Setting your financial goals for a time horizon of 5 years and more; strategies focused on your future financial needs. (ex: financial independence, saving for children’s future education, major purchases, retirement planning, estate planning)",
    "Manage My Cash Better": "Understanding and implementing financial tools and techniques to manage cash more effectively; strategies focused on cash flow management and wealth creation. (ex: reducing expenditures, loans and debt; increasing income and surplus savings; establishing investment accounts; maximizing employer benefits and retirement plans)",
    "My Investments": "Creating and implementing a strategy to grow your wealth through investments that align with your risk appetite, time horizon, and financial goals; involves identifying what you should invest in, how much risk you are comfortable taking, and what types of investments will help you grow your wealth over time. (ex: 401K plans, IRAs, Roth IRA, brokerage accounts, real estate, cryptocurrency, stock options, money market accounts) ",
    // "Other":"a. No definition  b. Fillable line where user can type in specific priority"
  };

  const checkAndFillData = async () => {
    setShowLoaderOne(true);
    const questions = await onboardingQuestions("What do you want help with first?");
    if (questions.status === 200) {
      // #69: guards the same crash class as QuestionSix/QuestionThree —
      // `.data` can still arrive undefined, or a malformed 200 body can
      // leave it non-array-but-truthy, and `allQuestions[0]` is read
      // unguarded at render (line ~200 below).
      setAllQuestions(Array.isArray(questions?.data) ? questions.data : []);
      const getOnboardingDetailsData = await getOnboardingDetails(questions?.data[0]?._id);
      if (
        getOnboardingDetailsData.status === 200 &&
        getOnboardingDetailsData.data?.error
      ) {

        // No 'message' key means data exists
        let temp = setDataForStates(
          questions.data[0],
          getOnboardingDetailsData.data[0],
          false
        );

        if (temp.selectedData.length > 0) {
          // Onboarding already done, modal shouldn't show
          setSelectedOptions(temp.selectedData);
          
        } else {
          // No previous onboarding, show modal
          // setIsModalOpen(true);
        }
        setRemainingOptions(temp.remainingData);
        setOtherInput(getOnboardingDetailsData.data?.data?.[0]?.others || "");
      } else {
        // 'message' exists, update logic to use 'data.data[0]'
        let temp = setDataForStates(
          questions.data[0],
          getOnboardingDetailsData.data?.data?.[0],
          false
        );

        if (temp.selectedData.length > 0) {
          setSelectedOptions(temp.selectedData);
        }
        setRemainingOptions(temp.remainingData);
        setOtherInput(getOnboardingDetailsData.data?.data?.[0]?.others || "");
      }
    }
    setShowLoaderOne(false); // Data fetching is done
  };


  useEffect(() => {
    checkAndFillData();
  }, []);

  const hideModal = () => {
    setIsModalOpen(false);
  };

  const handleDrop = (e, index, targetType) => {
    e.preventDefault();
    const option = e.dataTransfer.getData("option");
    const type = e.dataTransfer.getData("type");

    if (targetType === "selectedOptions" || type === "remainingOptions") {
      setSelectedOptions((prevSelectedOptions) => {
        const newSelectedOptions = [...prevSelectedOptions];
        const displacedOption = newSelectedOptions[index];
        newSelectedOptions[index] = option;

        if (displacedOption) {
          setRemainingOptions((prevRemainingOptions) => [
            ...prevRemainingOptions,
            displacedOption
          ]);
        }

        return newSelectedOptions;
      });

      setRemainingOptions((prevRemainingOptions) =>
        prevRemainingOptions.filter((item) => item !== option)
      );
    } else if (targetType === "remainingOptions" && type === "selectedOptions") {
      const draggedIndex = e.dataTransfer.getData("index");
      setRemainingOptions((prevRemainingOptions) => [
        ...prevRemainingOptions,
        option
      ]);

      setSelectedOptions((prevSelectedOptions) => {
        const newSelectedOptions = [...prevSelectedOptions];
        newSelectedOptions[draggedIndex] = null;
        return newSelectedOptions;
      });
    } else if (type === "selectedOptions") {
      const draggedIndex = e.dataTransfer.getData("index");
      setSelectedOptions((prevSelectedOptions) => {
        const newSelectedOptions = [...prevSelectedOptions];
        [newSelectedOptions[draggedIndex], newSelectedOptions[index]] = [
          newSelectedOptions[index],
          newSelectedOptions[draggedIndex]
        ];
        return newSelectedOptions;
      });
    }
  };


  const handleDragStart = (e, option, type, index) => {
    e.dataTransfer.setData("option", option);
    e.dataTransfer.setData("type", type);
    if (type === "selectedOptions") {
      e.dataTransfer.setData("index", index);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault()
  };

  const handleNextQuestion = async () => {
    setShowLoaderOne(true);
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    const selectedData = selectedOptions
      .filter((data) => data !== null && data !== "")
      .map((data) => ({
        name: data,
        value: ""
      }));

    const body = {
      clientId: currentUser?.user?._id,
      questionId: allQuestions[0]?._id,
      others: otherInput,
      selectedOptions: selectedData
    };

    if (isFromUserQuestionnaire) {
      const updateResponse = await setOnboardingData(body);
      setShowLoaderOne(false);
      if (updateResponse.status === 201) {
        navigate('/questionnaire');
      }
      return;
    }

    if (remainingOptions.length > 8) {
      setShowLoaderOne(false);
      dispatch(setSkipModalData(true));
      return;
    }

    const data = await setOnboardingData(body);
    setShowLoaderOne(false);
    if (data.status !== 201) {
      return;
    }

    const nextPath = currentUser?.user?.quickSetup === true ? '/q7' : '/q2';
    navigate(nextPath);
  };
  return (
    <>
      {showLoaderOne ? (
        <Loader />
      ) : (allQuestions.length > 0 && <div className="question-set">
        <div className="onboaring-quesn justify-content-between d-flex place-items-center">
          <h2>
            <span>{ quickSetup === true ? "" : "Q1" }</span>
            <div>{allQuestions[0].questionName}
              <br />
              <p>This helps your advisor focus on what matters most to you right now..</p></div>
          </h2>
          {!isFromUserQuestionnaire && (
            <button
              type="button"
              className="as-btn-secondary"
              onClick={() => { navigate('/dashboard') }}
            >
              Continue Later</button>)}
        </div>
        <div className="selected-option-box">
          {Array.from({ length: 3 }).map((_, index) => (
            <div
              key={_}
              className={`selected-option ${selectedOptions[index] ? "if_selected" : ""}`}
              draggable={selectedOptions[index] ? "true" : "false"}
              onDragOver={(e) => handleDragOver(e)}
              onDrop={(e) => handleDrop(e, index)}
              onDragStart={(e) => selectedOptions[index] && handleDragStart(e, selectedOptions[index], "selectedOptions", index)}
            >
              {selectedOptions[index] || index + 1}
            </div>
          ))}
        </div>


        <div className="mt-3">
          <div className="onboarding-label mb-3">
            Drag and drop to rank top 3 priorities order
          </div>
          <div
            className="priority-options"
            onDragOver={handleDragOver}
            onDrop={(e) => handleDrop(e, null, "remainingOptions")}
          >
            {remainingOptions.map((option) => (
              <div
                key={option}
                className="single-option"
                title={tooltipDescriptions[option]}
                draggable="true"
                onDragStart={(e) => handleDragStart(e, option, "remainingOptions")}
              >
                {option}
              </div>
            ))}
          </div>
        </div>
      </div>)}

      <div>
        {!showLoaderOne && (
          <div className="onboarding-footer">
            <div className="common-other-textbox mt-3 mb-3">
              <textarea
                name="otherText"
                id="otherText"
                placeholder="Something else"
                value={otherInput}
                onChange={(e) => setOtherInput(e.target.value)}
              ></textarea>
            </div>
            <div className="onboarding-footer-btns">
              <div className="d-flex justify-content-between w-100">
                {isFromUserQuestionnaire ? (
                  <>
                    <button
                      type="button"
                      className="as-btn-secondary"
                      onClick={() => {
                        navigate("/questionnaire");
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="as-btn-primary"
                      onClick={handleNextQuestion}
                    >
                      Update
                    </button>
                  </>
                ) : (
                  <>
                    <div></div>
                    <button
                      type="button"
                      className="as-btn-primary"
                      onClick={handleNextQuestion}
                    >
                     { quickSetup === true ? "About You →" : "Your Goals →" }
                    </button>
                  </>
                )}
              </div>
              <AIChatBot
                questionName={allQuestions[0]?.questionName}
                options={remainingOptions.concat(selectedOptions.filter(Boolean))}
                firstMsg="Hi! I'm here to help you identify your top financial priorities. Tell me about your current financial situation and what you're hoping to achieve."
              />
            </div>
          </div>
        )}
      </div>



      {isModalOpen && (
        <Modal
          size="lg"
          show={isModalOpen}
          aria-labelledby="documentPopupLabel"
          backdrop="static"
          keyboard={false}
          centered
        >
          <div className="modal-body">
            <h4 className="welcome-popup-head mt-3">
              Welcome to your Onboarding
            </h4>
            <div style={{ textAlign: "center", marginBottom: "5px" }}>
              <svg width="148" height="5" viewBox="0 0 148 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 3.5C2.46003 3.55832 4.91997 3.61164 7.37983 3.65996C29.5186 4.09484 51.6504 4.12478 73.7754 3.74978C95.9004 3.37478 118.019 2.59484 140.13 1.40996C142.587 1.27831 145.043 1.14165 147.5 1C145.04 0.941681 142.58 0.888362 140.12 0.840041C117.981 0.405158 95.8496 0.375215 73.7246 0.750215C51.5996 1.12522 29.4814 1.90516 7.37017 3.09004C4.91336 3.22169 2.45664 3.35835 0 3.5Z" fill="url(#paint0_linear_1_223)" />
                <defs>
                  <linearGradient id="paint0_linear_1_223" x1="45" y1="-7" x2="107.5" y2="9" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#D9D9D9" />
                    <stop offset="1" stopColor="#DBDBDB" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <div className="onboarding-vdo">
              {/* <video src={OnboardingVideo} loop autoPlay muted></video> */}
              <video src={OnboardingVideo} loop autoPlay></video>
            </div>
            <p className="text-center f-500 mb-4">
              To make the most of our services, please complete a quick 10-12
              question onboarding. This helps us understand your needs and goals.
            </p>
            <div className="text-center mb-3">
              <button
                type="button"
                className="as-btn-primary animated-btn start-onboarding-btn w-50 mb-4"
                data-dismiss="modal"
                onClick={hideModal}
              >
                Start Onboarding
              </button>
              <br />
              <NavLink className="skip-onboarding-btn" to="/dashboard">
                Skip for now
              </NavLink>
            </div>
          </div>
        </Modal>
      )}

    </>
  );
};

export default QuestionOne;
